// extracted by mini-css-extract-plugin
module.exports = {"headerCell":"VirtualTableHeaderCell-headerCell-2c0Et","sortIcon":"VirtualTableHeaderCell-sortIcon-1D-j_"};